import { combineReducers } from "redux";

import libraryCardReducer from "./libraryCardReducer";

const rootReducer = combineReducers({
  libraryCards: libraryCardReducer,
});

export default rootReducer;
